import { ReportConfiguration, ReportPageTemplate, ReportSection } from '@blk/simba';
import { ViewCategory } from '@ddt-web/config';
import { Observable } from 'rxjs';

export class AchoReportConfiguration extends ReportConfiguration {
	constructor(
		public readonly pages: ReportSection[],
		public readonly viewCategory: ViewCategory,
		public readonly pageTemplate?: ReportPageTemplate,
		public readonly componentReqIdMapping?: { [id: string]: Observable<string[]> }
	) {
		super(pages, pageTemplate);
	}

	public sortPages(): void {
		this.pages.sort((rs1, rs2) => rs1.order - rs2.order);
	}
}
